import React from "react";
import styled from "styled-components";

export default styled.img`
    position: relative;
    top: 8px;
    margin-right: 8px;
`;